"use client"

import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import mediusLogo from "../../Static/RawImages/black-ks-logo.png"
import Dropdown from "react-bootstrap/Dropdown"
import { FiChevronDown } from "react-icons/fi"
import useAuthStore from "../../store/authStore"
import useGeneralStore from "../../store/generalStore"
import { logout } from "../../API/commonApis"

function Header() {
  const removeUser = useAuthStore((state) => state.removeUser)
  const userData = useAuthStore((state) => state.userData)
  const totalResultFetched = useGeneralStore((state) => state.total_result_fetched)
  const isSidebarOpen = useGeneralStore((state) => state.is_sidebar_open)

  const [urlPointer, setUrlPointer] = useState("Litigation Panel")
  const [showTotalResultCount, seShowTotalResultCount] = useState(false)

  const location = useLocation()

  function logoutUser() {
    logout()
    removeUser()
  }

  function getUrlPointer() {
    const showResultTemp = false
    let urlPointerTemp = "Litigation Panel"
    const { pathname } = location

    if (pathname === "/" || pathname === "/admin/litigation/batch" || pathname === "/litigation/batch") urlPointerTemp = "Batch"
    else if (pathname === "/admin/litigation/cases" || pathname === "/litigation/cases") urlPointerTemp = "Cases"
    else if (pathname.startsWith("/admin/invoice") || pathname.startsWith("/invoice")) urlPointerTemp = "Invoices"
    else if (pathname.startsWith("/admin/assignments") || pathname.startsWith("/assignments")) urlPointerTemp = "Assignments"
    setUrlPointer(urlPointerTemp)
    seShowTotalResultCount(showResultTemp)
  }

  useEffect(() => {
    getUrlPointer()
  }, [location])

  return (
    <div style={{ width: "100%", paddingTop: "72px", position: "relative", zIndex: "100" }}>
      <header
        className="d-flex align-center header justify-between"
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          paddingLeft: isSidebarOpen ? "178px" : "62px",
          width: "100%",
          transition: "all ease 0.5s",
          zIndex: "99",
        }}
      >
        <div className="d-flex align-center header-left mb-lg-0 mb-2">
          <h1>{urlPointer}</h1>
          {showTotalResultCount && (
            <small>
              Total Result{totalResultFetched === 1 ? "" : "s"} : {totalResultFetched || 0}
            </small>
          )}
        </div>

        <div className="d-flex align-center header-right">
          <Dropdown>
            <Dropdown.Toggle>
              <div className="d-flex align-items-center justify-content-center gap-1 text-dark">
                <img
                  src={userData?.logo_url || mediusLogo}
                  style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "50%" }}
                  alt="User"
                />
                <p className="m-0" style={{ fontWeight: "normal" }}>
                  {userData?.full_name || ""}
                </p>
                <FiChevronDown style={{ fontSize: "18px" }} />
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={logoutUser}>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </header>
    </div>
  )
}

export default Header
